import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Server } from "lucide-react";
import { Button } from "../../../components/ui/button";

const ProgressItem = ({ label, value, color, change }) => {
  return (
    <div>
      <div className="flex justify-between mb-4">
        <span className="text-sm text-gray-400">{label}</span>
        <div className="flex items-center">
          <span className="text-sm font-medium">{value.toFixed(1)}%</span>
          {change && (
            <span className={`ml-8 text-xs ${change.includes('+') ? 'text-red-400' : 'text-green-400'}`}>
              {change}
            </span>
          )}
        </div>
      </div>
      <div className="w-full bg-[#232834] rounded-full h-2.5">
        <div 
          className={`${color} h-2.5 rounded-full`} 
          style={{ width: `${value}%` }}
        ></div>
      </div>
    </div>
  );
};

const SystemHealth = ({ storageData }) => {

  return (
    <Card className="bg-[#2c3440] dark:bg-[#1A1F2C] text-white border-none shadow-lg hover:shadow-xl transition-all lg:col-span-1 p-24 h-[500px] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
      <CardHeader className="pb-8">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl font-bold text-white flex items-center">
            <Server className="h-5 w-5 mr-8 text-[#9b87f5]" />
            System Health
          </CardTitle>
          <Button variant="link" className="text-[#1EAEDB]" asChild>
             <a href="/accounts" style={{ color: "#1EAEDB" }}>View Status</a>
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <ProgressItem
            label="API Uptime" 
            value={99.8} 
            color="bg-green-500" 
          />
          <ProgressItem 
            label="Database Performance" 
            value={92.3} 
            color="bg-blue-500" 
          />
          <ProgressItem 
            label="Storage Usage" 
            value={storageData.value} 
            color={storageData.value > 80 ? "bg-red-500" : "bg-yellow-500"} 
            change={storageData.change}
          />
          <ProgressItem 
            label="Image Processing" 
            value={88.1} 
            color="bg-purple-500" 
          />
          <ProgressItem 
            label="Email Delivery Rate" 
            value={98.4} 
            color="bg-green-500" 
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default SystemHealth;